"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = require("react");
var ui_1 = require("@vidazoo/ui");
var moment = require("moment");
var TokenRow = /** @class */ (function (_super) {
    tslib_1.__extends(TokenRow, _super);
    function TokenRow(props, context) {
        var _this = _super.call(this, props, context) || this;
        _this.onDelete = function () {
            var _a = _this.props, onDelete = _a.onDelete, token = _a.token;
            onDelete(token);
        };
        return _this;
    }
    TokenRow.prototype.render = function () {
        var token = this.props.token;
        return (React.createElement("tr", null,
            React.createElement(ui_1.TableCell, null, token.startToken + "......" + token.endToken),
            React.createElement(ui_1.TableCell, null, moment(token.created).format("MMM DD, YYYY")),
            React.createElement(ui_1.TableCell, null,
                React.createElement(ui_1.LinkButton, { onClick: this.onDelete, iconName: "icon-delete", iconSize: 1.8 }))));
    };
    TokenRow.defaultProps = {};
    return TokenRow;
}(React.Component));
exports.default = TokenRow;
